import i18n from '@/locales/i18n';
import { message } from '@koi-design/uxd-ui';
// import { loginOutApi } from '@/api/auge';
import { debounce } from 'lodash-es';
import { handleSessionExpired } from '@libs/authSession';
import store from '../store';

const requestConfig = {};
requestConfig.API_REQUEST_BASE_URL = '';
requestConfig.API_REQUEST_CONTENT_TYPE = 'application/json';
requestConfig.API_REQUEST_TIMEOUT = 60000 * 5;
requestConfig.API_SUCCESS_CODE = '000000';
requestConfig.API_EXPIRED_CODE = '400001';
requestConfig.EXPIRED_MESSAGE = i18n.global.t(
  'config.requestConfig.38c9a6a47f07a804aaca63409895c3ac'
);
requestConfig.LOGIN_URL = `${window.location.origin}/login`;
requestConfig.EXPIRED_TO_URL = `${window.location.origin}/login`;
requestConfig.TOKEN_KEY = 'Authorization';
const domescitLang = localStorage.getItem('language') || 'zh_CN';
// Request-level language code. Japanese has its own bundle, so it is passed
// through as ja_JP; every other overseas locale (en_gaia / unset) keeps
// sending en_US, which is what the APIs expect today.
const defaultLang = IS_DOMESTIC
  ? domescitLang
  : domescitLang === 'ja_JP'
    ? 'ja_JP'
    : 'en_US';

export const getLanguage = () => {
  return defaultLang;
};

// Parse URL parameters, compatible with both search and hash router modes
const getUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(
    window.location.hash.split('?')[1] || ''
  );
  return { urlParams, hashParams };
};

const getUrlSource = () => {
  const { urlParams, hashParams } = getUrlParams();
  const source = urlParams.get('source') || hashParams.get('source');

  const companySources = new Set(['enterprise', 'workshop', 'control_center']);
  const companyRoutes = new Set([
    '/enterprise',
    '/enterpriseApproval',
    '/agentMonitor',
    '/agentManagement'
  ]);

  const currentPath = window.location.pathname;
  const isCompany =
    companySources.has(source) || companyRoutes.has(currentPath);

  return isCompany ? 'company' : '';
};

// Extract robotId from URL only when source is agentToResource
const getRobotId = () => {
  const { urlParams, hashParams } = getUrlParams();
  const source = urlParams.get('source') || hashParams.get('source');
  if (source === 'agentToResource') {
    return (
      urlParams.get('robotId') ||
      hashParams.get('robotId') ||
      urlParams.get('botId') ||
      hashParams.get('botId') ||
      ''
    );
  }
  return '';
};

requestConfig.API_REQUEST_HEADERS = () => {
  const robotId = getRobotId();
  return {
    language: defaultLang,
    'X-Auth-Provider': localStorage.getItem('auth_provider') || '',
    sessionId: localStorage.getItem('sessionId') || '',
    homeland: store.getters?.homelandInfo?.homeland || '',
    'url-source': getUrlSource(),
    // Only include robotId header when source is agentToResource and robotId exists
    ...(robotId ? { robotId } : {})
  };
};
requestConfig.GET_TOKEN = () => {
  return `Bearer ${localStorage.getItem('sbtToken')}`;
};

requestConfig.EXPIRED_METHOD = debounce(
  async response => {
    handleSessionExpired(response);
  },
  300,
  { leading: true, trailing: false }
);

requestConfig.API_RESPONSE_ERROR_METHOD = status => {
  switch (status) {
    case 401:
      // message.error(
      //   i18n.global.t('config.requestConfig.9c7c69ad52a08aec796f56d96da10624')
      // );
      // window.location.href = `${window.location.origin}/login`;
      break;
    case 404:
      message.error(
        i18n.global.t('config.requestConfig.cf7f2c4b25a93dd65ef1c9fc3d981018')
      );
      break;
    case 500:
      message.error(
        i18n.global.t('config.requestConfig.cba2c6fe6074c52d752f9d0029a677f2')
      );
      break;
    default:
      message.error(
        i18n.global.t('config.requestConfig.cba2c6fe6074c52d752f9d0029a677f2')
      );
  }
};
export default requestConfig;
